import React, { Suspense } from "react";
import { Route, Switch, withRouter } from "react-router-dom";

import LoadTop from "../components/Common/SectionTitle/ScrollTop/LoadTop";

import Loader from "../components/Loader/Loader";
import BlockChain from "../pages/Blockchain/BlockChain";
import pageTitles from "../pageTitles";

const Home = React.lazy(() => import("../pages/home"));

// About US

const About = React.lazy(() => import("../pages/about"));

const Leadership = React.lazy(() => import("../pages/leadership"));

const Global_Companies = React.lazy(() => import("../pages/globel-companies"));

const Global_Presence = React.lazy(() => import("../pages/global-presence"));

// Services

const Web_Mobile_Dev = React.lazy(
  () => import("../pages/web_mobile_development"),
);

const AI_ML_Solutions = React.lazy(() => import("../pages/AI-ML-Solutions"));

const Fintech_App_Eng = React.lazy(
  () => import("../pages/Fintech_App_Engineering"),
);

const Salesforce_Consulting = React.lazy(
  () => import("../pages/Salesforce_Consulting"),
);

const cloud_and_devops = React.lazy(() => import("../pages/Cloud_devops"));

const StaffAugmentation = React.lazy(() => import("../pages/staff_augmenatation"));


// Resources

const CurrentopeningsSec = React.lazy(
  () => import("../pages/Current_openings/Currentopenings"),
);

const Contact = React.lazy(() => import("../pages/contact"));

const Blog = React.lazy(() => import("../pages/blog"));

const BlogDetail = React.lazy(() => import("../pages/blog/BlogDetail"));

const White_Paper = React.lazy(() => import("../pages/white-paper"));

const WhitePaperDetail = React.lazy(
  () => import("../pages/white-paper/WhitePaperDetail"),
);

const ErrorPage = React.lazy(() => import("../pages/ErrorPage"));

const App = ({ location }) => {
  React.useEffect(() => {
    const defaultTitle = "Metaqualt";

    if (pageTitles[location.pathname]) {
      document.title = pageTitles[location.pathname] + " | Metaqualt";
    } else {
      document.title = defaultTitle;
    }
  }, [location.pathname]);

  return (
    <div className="App">
      <LoadTop />

      <Suspense
        fallback={
          <div>
            <Loader />
          </div>
        }
      >
        <Switch>
          <Route exact path="/" component={Home} />

          {/* About Us */}

          <Route path="/company-overview" component={About} />

          <Route path="/leadership" component={Leadership} />

          <Route path="/group-companies" component={Global_Companies} />

          <Route path="/global-presence" component={Global_Presence} />

          {/* Services */}

          <Route path="/AI-LLM-Solutions" exact component={AI_ML_Solutions} />

          <Route path="/blockchain" exact component={BlockChain} />

          <Route
            path="/fintech-app-engineering"
            exact
            component={Fintech_App_Eng}
          />

          <Route
            path="/salesforce-consulting"
            exact
            component={Salesforce_Consulting}
          />

          <Route
            path="/web-mobile-app-development"
            exact
            component={Web_Mobile_Dev}
          />

          <Route path="/cloud-devops" exact component={cloud_and_devops} />

          <Route path="/staff-augmentation" exact component={StaffAugmentation} />


          {/* Resources */}

          <Route
            path="/current-openings"
            exact
            component={CurrentopeningsSec}
          />

          <Route path="/blog" exact component={Blog} />

          <Route path="/blog/:slug" component={BlogDetail} />

          <Route path="/white-paper" exact component={White_Paper} />

          <Route path="/white-paper/:slug" component={WhitePaperDetail} />

          <Route path="/contact-us" component={Contact} />

          {/* Catch-all route for undefined paths */}
          <Route component={ErrorPage} />
        </Switch>
      </Suspense>
    </div>
  );
};

export default withRouter(App);
